import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    textAlign: 'center',
    padding: '2rem',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    animation: 'fadeInUp 0.6s ease-out',
  },
  code: {
    fontSize: '8rem',
    fontWeight: 800,
    color: '#2c3e50',
    margin: 0,
    lineHeight: 1,
    letterSpacing: '-4px',
  },
  message: {
    fontSize: '1.5rem',
    color: '#7f8c8d',
    margin: '1rem 0 2rem',
  },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.85rem 2rem',
    fontSize: '1rem',
    fontWeight: 600,
    color: '#fff',
    backgroundColor: '#2c3e50',
    border: 'none',
    borderRadius: '8px',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
  },
};

const keyframes = `
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`;

function NotFound() {
  return (
    <>
      <style>{keyframes}</style>
      <div style={styles.container}>
        <p style={styles.code}>404</p>
        <p style={styles.message}>Sayfa Bulunamadı</p>
        <Link
          to="/"
          style={styles.button}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#1a252f';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#2c3e50';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <FaHome />
          Ana Sayfaya Dön
        </Link>
      </div>
    </>
  );
}

export default NotFound;
